/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   button.mat-accent[_ngcontent-%COMP%], [_nghost-%COMP%]   button.mat-primary[_ngcontent-%COMP%]{background-color:#182365}[_nghost-%COMP%]   .material-icons[_ngcontent-%COMP%]{color:#000;padding:5px}[_nghost-%COMP%]   .material-icons[_ngcontent-%COMP%]:hover{text-decoration:none!important}[_nghost-%COMP%]   code[_ngcontent-%COMP%]{white-space:pre;background:#e7e9eb;display:block;color:#000;padding:20px 0;border-left:4px solid var(--color-tangerine,orange)}"];
export { styles as styles };
